import React from "react";

export function getGoogleAnalyticsScriptAmpHeader(
  googleAnalyticsId: string | null | undefined
) {
  if (process.env.NODE_ENV !== "production" || !googleAnalyticsId) {
    return <></>;
  }

  return (
    <>
      <script
        async
        custom-element="amp-analytics"
        src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
      />
    </>
  );
}

export function getGoogleAnalyticsScriptAmpBody(
  googleAnalyticsId: string | null | undefined
) {
  if (process.env.NODE_ENV !== "production" || !googleAnalyticsId) {
    return <></>;
  }

  return (
    <>
      <amp-analytics type="gtag" data-credentials="include">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: `
              {
                "vars" : {
                  "gtag_id": "${googleAnalyticsId}",
                  "config" : {
                    "${googleAnalyticsId}": { "groups": "default" }
                  }
                }
              }
            `,
          }}
        ></script>
      </amp-analytics>
    </>
  );
}
